import { render, staticRenderFns } from "./LandingSelect.vue?vue&type=template&id=352b7efa&scoped=true"
import script from "./LandingSelect.vue?vue&type=script&lang=js"
export * from "./LandingSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b7efa",
  null
  
)

export default component.exports